<template>
  <div>
    <b-card class="main">
      <header slot="header">
        <b-row>
          <b-col :title="labels.modules.title" md="12">
            {{ labels.modules.title }}
          </b-col>
        </b-row>
      </header>
      <b-row>
        <b-col cols="12">
          <b-nav class="link">
            <b-nav-item
              key="informations"
              :title="labels.modules.engagement"
              :active="true"
            >
              {{ labels.modules.engagement }}
            </b-nav-item>
          </b-nav>
          <b-row class="mt-3">
            <b-col cols="12" xl="12" class="mb-4">
              <b-form-group
                class="settings-label"
                label-for="settings"
                :label="labels.modules.settings"
              >
                <b-form-checkbox
                  name="checkbox-engagement"
                  v-model="settings.modules.engagement"
                  switch
                  @change="changeModulesSettings('engagement', $event)"
                >
                  {{ labels.modules.engagementSurvey }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              xl="6"
              class="mb-3"
              v-if="settings.modules.engagement"
            >
              <b-form-group
                label-for="select-period"
                :label="labels.engagement.period.label"
                :description="labels.engagement.period.description"
              >
                <b-form-select
                  id="select-period"
                  class="account-form-input"
                  :value="settings.surveyIntervalDays"
                  size="lg"
                  @change="changeSurveyIntervalDays"
                >
                  <option value="">
                    {{ labels.engagement.period.select }}
                  </option>
                  <option value="weekly">
                    {{ labels.engagement.period.weekly }}
                  </option>
                  <option value="biweekly">
                    {{ labels.engagement.period.biweekly }}
                  </option>
                  <option value="monthly">
                    {{ labels.engagement.period.monthly }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="12" xl="6" v-if="settings.modules.engagement">
              <b-form-group
                label-for="select-next-survey"
                :label="labels.engagement.nextDeliveySurveyDate.label"
                :description="
                  labels.engagement.nextDeliveySurveyDate.description
                "
              >
                <b-form-input
                  id="select-next-survey"
                  class="account-form-input"
                  type="date"
                  :value="settings.deliverySurveyDate"
                  @update="changeDeliverySurveyDate"
                >
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-list-group flush class="mt-4">
        <b-list-group-item>
          <b-row align-h="end">
            <b-button
              :variant="loading ? 'link' : 'primary'"
              class="mt-3"
              :disabled="settings.surveyIntervalDays === '' || loading"
              @click="saveSettings"
            >
              {{ labels.save }}
            </b-button>
          </b-row>
        </b-list-group-item>
      </b-list-group>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { HIGH } from '@/helpers/messages-priority'

export default {
  data() {
    return {
      loading: false,
    }
  },

  computed: {
    ...mapGetters({
      resources: 'resources',
      settings: 'account/settings',
    }),

    labels() {
      return this.resources.component.accountModulesConfiguration
    },
  },

  methods: {
    async saveSettings() {
      this.loading = true
      await this.$store
        .dispatch('account/saveSettings', this.settings)
        .then(() => {
          this.$root.$emit('app:message:show', {
            priority: HIGH,
            text: this.labels.saveSuccess,
            status: 'success',
          })
        })
        .catch(() => {
          this.$root.$emit('app:message:show', {
            priority: HIGH,
            text: this.labels.saveError,
            status: 'danger',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    changeDeliverySurveyDate(deliverySurveyDate) {
      this.$store.dispatch('account/changeSettings', {
        field: 'deliverySurveyDate',
        value: deliverySurveyDate,
      })
    },
    changeSurveyIntervalDays(surveyIntervalDays) {
      this.$store.dispatch('account/changeSettings', {
        field: 'surveyIntervalDays',
        value: surveyIntervalDays,
      })
    },
    changeModulesSettings(field, value) {
      this.$store.dispatch('account/changeModulesSettings', { field, value })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';

.main {
  &.card {
    .card-header {
      font-size: 24px;
    }

    .account-form-input {
      cursor: pointer;
      font-size: 0.9rem !important;
      height: 45px !important;
      border-radius: 10px !important;
      background-color: map-get($theme-colors, 'white') !important;
      border-color: var(--gray07) !important;
    }

    .btn {
      border-radius: 10px !important;
      min-width: 160px;
    }

    /deep/ .form-group:not(.settings-label) {
      label,
      legend {
        color: map-get($theme-colors, 'primary') !important;
        position: absolute;
        top: -18px;
        margin-left: 20px;
        font-size: 12px;
      }
      small {
        font-size: 12px;
        margin-left: 15px;
      }
    }
    /deep/ .settings-label {
      .custom-switch {
        input,
        label {
          cursor: pointer;
        }
      }

      label {
        color: map-get($theme-colors, 'primary') !important;
        margin-left: 20px;
        font-size: 0.9rem !important;

        &:first-child {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
